import { AnalyticsConfig, AppConfig } from '@neptune/config-core-domain';

import config from 'config';

import * as intercom from './intercom';

initAnalytics(config);

function initAnalytics(config: AppConfig & AnalyticsConfig) {
  if (config.appEnv === 'dev') {
    // eslint-disable-next-line
    console.warn(
      'It looks like you are in local development mode so that analytics script will not be attached',
    );
    return;
  }

  intercom.init(config);
}
